import React from "react";

const Button = ({className, url, onClick, children}) => {
    return (
        <a className={className} href={url} onClick={onClick}>
            {children}
        </a>
    );
}

export default Button;